import styled from '@/styles';

export const Card = styled('section', {
  backgroundColor: '#FFFFFF',
  border: '1px solid #DADADA',
  borderRadius: '8px',
  minWidth: 0,
});

export const CardBody = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '16px 20px',
});

export const Title = styled('h2', {
  margin: 0,
  fontSize: '16px',
  fontWeight: 700,
});

export const Caption = styled('span', {
  fontSize: '13px',
  color: '#5A5A5A',
});

export const Label = styled('span', {
  fontSize: '13px',
  color: '#3D3D3D',
});

export const Banner = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '10px',
  padding: '12px 16px',
  borderRadius: '8px',
  variants: {
    tone: {
      amber: { backgroundColor: '#FFF4D8', color: '#4D3600' },
      red: { backgroundColor: '#FFDFD8', color: '#6E0106' },
      grey: { backgroundColor: '#EDEDED', color: '#3D3D3D' },
    },
  },
});

export const Row = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '10px',
});

export const Divider = styled('div', {
  borderTop: '1px solid #EDEDED',
  paddingTop: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
});

export const Field = styled('label', {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  fontSize: '13px',
  fontWeight: 600,
  color: '#3D3D3D',
});

export const Select = styled('select', {
  font: 'inherit',
  fontSize: '14px',
  border: '1px solid #BDBDBD',
  borderRadius: '6px',
  padding: '8px 10px',
  backgroundColor: '#FFFFFF',
  color: '#1E1E1E',
});

export const ErrorText = styled('span', {
  color: '#B0030A',
  fontSize: '13px',
  fontWeight: 600,
});
